import { render, staticRenderFns } from "./wishlist.vue?vue&type=template&id=68e56d0d&scoped=true&"
import script from "./wishlist.vue?vue&type=script&lang=js&"
export * from "./wishlist.vue?vue&type=script&lang=js&"
import style0 from "./wishlist.vue?vue&type=style&index=0&id=68e56d0d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e56d0d",
  null
  
)

export default component.exports